import { gql } from "@apollo/client";

export const PARCELS_UPDATE = gql`
mutation updateParcel($input: ParcelUpdateInput!){
  updateParcel(input: $input){
    error
    code
    message
    data{
        parcel_UID
        parcel_size
        parcel_value
        parcel_additional_info
        parcel_description
        parcel_amount_to_collect
    
    }
  }
}
`;
